// Desktop: link columns are clipped until "Rodyti daugiau" is pressed.
// Mobile: each column folds open on its own. Without JS everything is shown.
export default function initFooter(footer) {
  footer.classList.add("is-collapsible")

  const more = footer.querySelector(".hv-footer__more")
  const moreText = footer.querySelector(".hv-footer__more-text")
  more.addEventListener("click", () => {
    const expanded = more.getAttribute("aria-expanded") !== "true"
    more.setAttribute("aria-expanded", String(expanded))
    footer.classList.toggle("is-expanded", expanded)
    moreText.textContent = expanded ? "Rodyti mažiau" : "Rodyti daugiau"
  })

  footer.querySelectorAll(".hv-footer__toggle").forEach((toggle) => {
    toggle.addEventListener("click", () => {
      const open = toggle.getAttribute("aria-expanded") !== "true"
      toggle.setAttribute("aria-expanded", String(open))
      toggle.closest(".hv-footer__col").classList.toggle("is-open", open)
    })
  })
}
